import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import StripeVerificationPage from './component';
import { getHostedOnboardingUrl } from '@rental-manager/actions/requests';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onNext: async (): Promise<void> => {
    await dispatch(closeNotification());
    const hostedOnboardingResponse = await dispatch(getHostedOnboardingUrl({ propertyId }));
    await checkRequestActionSuccess(hostedOnboardingResponse);
    window.location = hostedOnboardingResponse.payload.data.url;
  },
  onClose: async (): Promise<void> => {
    await dispatch(push(baseUrl));
  },
  showModalNotification: (notificationType) => dispatch(showModalNotification(notificationType)),
});
export default connect(null, mapDispatchToProps)(StripeVerificationPage);
